import React from 'react';
import PropTypes from 'prop-types';

const RightArrow = ({ opacity = 1, isBothArrow = true, size = 24, stroke = '#738DA6' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{ opacity }}
        >
            {isBothArrow && (
                <path
                    d='M13 17L18 12L13 7'
                    stroke={stroke}
                    strokeWidth={2}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            )}
            <path
                d='M6 17L11 12L6 7'
                stroke={stroke}
                strokeWidth={2}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default RightArrow;

RightArrow.propTypes = {
    opacity: PropTypes.number,
};
